import { ValidationSchemaType } from 'hooks/useForm';
import { Place } from '../types/dtos';

export const COUNTRIES = {
    SRB: 'Srbija',
};

export const PLACE_INITIAL_FIELDS: Place = {
    name: '',
    phoneNumber: '',
    street: '',
    streetNumber: '',
    floor: '',
    apartment: '',
    country: COUNTRIES.SRB,
    longitude: '',
    latitude: '',
    zipCode: '',
    minimumOrderAmount: '',
    description: '',
    terminalId: '',
    websiteId: '',
    cityId: '',
    workingHours: [
        {
            dayOfWeek: 'Monday',
            openingTime: '00:00',
            closingTime: '00:00',
            isClosed: false,
        },
        {
            dayOfWeek: 'Tuesday',
            openingTime: '00:00',
            closingTime: '00:00',
            isClosed: false,
        },
        {
            dayOfWeek: 'Wednesday',
            openingTime: '00:00',
            closingTime: '00:00',
            isClosed: false,
        },
        {
            dayOfWeek: 'Thursday',
            openingTime: '00:00',
            closingTime: '00:00',
            isClosed: false,
        },
        {
            dayOfWeek: 'Friday',
            openingTime: '00:00',
            closingTime: '00:00',
            isClosed: false,
        },
        {
            dayOfWeek: 'Saturday',
            openingTime: '00:00',
            closingTime: '00:00',
            isClosed: false,
        },
        {
            dayOfWeek: 'Sunday',
            openingTime: '00:00',
            closingTime: '00:00',
            isClosed: false,
        },
    ],
};

export const PLACE_FIELDS_SCHEMA: ValidationSchemaType<Place> = {
    name: {
        required: true,
        maxLength: 100,
    },
    street: {
        required: true,
        maxLength: 100,
    },
    streetNumber: {
        required: true,
        maxLength: 20,
    },
    cityId: {
        required: true,
    },
    zipCode: {
        required: true,
    },
    country: {
        required: true,
    },
    phoneNumber: {
        required: true,
    },
    terminalId: {
        required: true,
    },
    longitude: {
        required: true,
        type: 'longitude',
    },
    latitude: {
        required: true,
        type: 'latitude',
    },
    minimumOrderAmount: {
        required: true,
        type: 'positive_number',
        min: 1,
    },
};
